/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
import React, { useEffect } from "react"
import { setGlobal, addCallback, removeCallback } from "reactn"

const GlobalState = ({ children }) => {
  const initialState = {
    showInfo: false,
  }

  const alertState = global => {
    console.log("New global state:")
    console.log(global)
  }

  addCallback(alertState)
  removeCallback(alertState)

  useEffect(() => {
    setGlobal({ ...initialState })
  }, [])

  return <React.Fragment>{children}</React.Fragment>
}

export default GlobalState
